import * as React from "react";
import { useNavigate } from "react-router-dom"
import { Button } from "@mui/material/";

export default function AlertNoRecordFound() {

  const navigate = useNavigate();
  return (
    <div
      style={{
        backgroundColor: "#FFF4E5",
        padding: "20px",
        borderRadius: "8px",
        border: "1px solid #FFC27B",
        color: "#8A4A00",
        textAlign: "center",
        marginTop: "30px",
        fontSize: "15px",
        fontWeight: 500,
        width: "90%",
        marginLeft: "auto",
        marginRight: "auto"
      }}
    >
      <div
        style={{
          fontSize: "18px",
          marginBottom: "8px",
          fontWeight: 600
        }}
      >
        Kayıt Bulunamadı
      </div>

      <div style={{ marginBottom: "20px" }}>
        Belirtilen kriterlerde kayıt bulunmamaktadır.
      </div>
    </div>

  );
}